<span class="chip truncate" [ngStyle]="{'display':chip.display}" [title]="chip.value">
  <i class="fa fa-minus-circle" aria-hidden="true" (click)="clearVal($event)" [title]="titleMSG"></i>
  {{chip.name}}<span *ngIf="chip.value">: {{chip.value}}</span>
</span>

